import axios from '../axios'

/*
 * 用户管理模块
 */

// 查询
export const selectByPage = (data) => {
    return axios({
        url: '/admin/member/selectByPage',
        method: 'post',
        data
    })
}
//
export const update = (data) => {
    return axios({
        url: '/admin/member/update',
        method: 'post',
        data
    })
}

export const batchDisable = (data) => {
    return axios({
        url: '/admin/member/batchDisable',
        method: 'post',
        data
    })
}

export const batchEnabled = (data) => {
    return axios({
        url: '/admin/member/batchEnabled',
        method: 'post',
        data
    })
}

export const logoff = (params) => {
    return axios({
        url: '/admin/member/logoff',
        method: 'get',
        params
    })
}
export const batchLogoff = (data) => {
    return axios({
        url: '/admin/member/batchLogoff',
        method: 'post',
        data
    })
}

export const logoffCancel = (data) => {
    return axios({
        url: '/admin/member/logoffCancel',
        method: 'post',
        data
    })
}

//批量设置佣金比
export const batchSetCommission = (data) => {
    return axios({
        url: '/admin/member/batchSetCommission',
        method: 'post',
        data
    })
}

export const bindParentMember = (data) => {
    return axios({
        url: '/admin/member/bindParentMember',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/customer.js